import { render, staticRenderFns } from "./RgpMaterialPicker.vue?vue&type=template&id=708ae1dc&scoped=true&"
import script from "./RgpMaterialPicker.vue?vue&type=script&lang=js&"
export * from "./RgpMaterialPicker.vue?vue&type=script&lang=js&"
import style0 from "./RgpMaterialPicker.vue?vue&type=style&index=0&id=708ae1dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ae1dc",
  null
  
)

export default component.exports